import { addNewAttendanceShiftFailure, addNewAttendanceShiftSuccess,
  editAttendanceShiftFailure, editAttendanceShiftSuccess,
  getAllAttendanceShiftFailure, getAllAttendanceShiftSuccess
 } from "../constants/attendanceShift";
 import { showNotification } from "./notification";
 import { getAllAttendanceShiftsApi } from "../../apis/shift";
 import { editAttedanceShiftApi } from "../../apis/shift";

 function allShiftsSuccess(payload) {
  return ({type: getAllAttendanceShiftSuccess, payload})
}

function allShiftsFailure() {
  return ({type: getAllAttendanceShiftFailure})
}

function editShiftDataSuccess(payload) {
  return ({type: editAttendanceShiftSuccess, payload})
}

function editShiftDataFailure() {
  return ({type: editAttendanceShiftFailure})
}

// export function getAttendanceShifts(query) {
//   return ((dispatch) => {
//     getAllAttendanceShiftsApi(query).then(
//       (res) => {
//         if (res) {
//           dispatch(allShiftsSuccess(res))
//         }
//       },
//       (error) => {
//         dispatch(allShiftsFailure())
//       }
//     )
//   })
// }

export function getAttendanceShifts(query) {
  return async (dispatch) => {
    try {
      // If downloadFile flag is passed, call download API instead
      if (query.downloadFile) {
        const response = await getAllAttendanceShiftsApi(query); // should return CSV string or ArrayBuffer
      
        // If response is ArrayBuffer, convert to string first
        let csvData;
        if (response instanceof ArrayBuffer) {
          csvData = new TextDecoder("utf-8").decode(response);
        } else {
          csvData = response; // if already string
        }
      
        const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "attendance.csv";
        document.body.appendChild(link);
        link.click();
        link.remove();
        return;
      }

      // Normal API flow
      const res = await getAllAttendanceShiftsApi(query);
      if (res) {
        dispatch(allShiftsSuccess(res));
      } else {
        dispatch(allShiftsFailure());
      }
    } catch (error) {
      dispatch(allShiftsFailure());
      console.error("Error in getAttendanceShifts:", error);
    }
  };
}
export function editAttendanceShift(query) {
  return ((dispatch) => {
    editAttedanceShiftApi(query).then(
      (res) => {
          dispatch(editShiftDataSuccess(query));
          dispatch(showNotification({
            type: "success",
            message: "Success",
            description: "Attendance Marked Successfully"
          }));
      },
      (error) => {
        dispatch(editShiftDataFailure());
        dispatch(showNotification({
          type: "error",
          message: "Unable to Mark the Attendance",
          description: error?.message
        }));
      }
    )
  })
}